export default __webpack_public_path__ + "static/compliance-9669b846a5dd9fb79c17cf15c9bf796e.svg";